
















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {

  public $material: any;

  constructor() {
    super();
    console.log('App constructor');
    console.log(`Running in ${process.env.NODE_ENV}`);
    this.$material.theming.theme = 'myTheme';
  }

  public mounted() {
    console.log('App mounted');
  }

}
